import { addMessages } from '@hana/i18n';

// Khoá chuỗi cjob.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'cjob.1': "Tính lại costing",
  'cjob.2': "Cách tính lợi nhuận",
  'cjob.3': "Chia lợi nhuận",
});
addMessages('en', {
  'cjob.1': "Recalculate costing",
  'cjob.2': "Profit calculation",
  'cjob.3': "Profit split",
});
